document.addEventListener('DOMContentLoaded', () => {
  const originalBtn = document.querySelector('.product-form__submit');
  const stickyWrap = document.getElementById('sticky-atc');

  if (!originalBtn || !stickyWrap) return;

  const form = originalBtn.closest('form');
  if (!form) return;

  // Clone once
  const stickyBtn = originalBtn.cloneNode(true);
  stickyBtn.removeAttribute('id');

  // Cache sticky inner elements
  const stickyText = stickyBtn.querySelector('span');
  const stickySpinner = stickyBtn.querySelector('.loading-overlay__spinner');

  stickyWrap.innerHTML = '';
  stickyWrap.appendChild(stickyBtn);

  // Track submission lock to prevent multi-click weirdness
  let inFlight = false;

  // Helper: apply loading visuals to a button (matches Dawn behavior)
  function setLoading(btn, isLoading) {
    const text = btn.querySelector('span');
    const spinner = btn.querySelector('.loading-overlay__spinner');

    if (text) text.classList.toggle('hidden', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);

    btn.classList.toggle('is-loading', isLoading);
    btn.disabled = isLoading || originalBtn.disabled;
  }

  // Helper: mirror text + disabled + loading state from original -> sticky
  function mirrorFromOriginal() {
    // Mirror disabled
    stickyBtn.disabled = originalBtn.disabled || inFlight;

    // Mirror text content (don’t replace innerHTML)
    const origText = originalBtn.querySelector('span');
    if (origText && stickyText) stickyText.textContent = origText.textContent;

    // Mirror loading visibility by reading "hidden" classes
    const origSpinner = originalBtn.querySelector('.loading-overlay__spinner');
    const origIsLoading =
      (origText && origText.classList.contains('hidden')) ||
      (origSpinner && !origSpinner.classList.contains('hidden')) ||
      originalBtn.classList.contains('loading') ||
      originalBtn.classList.contains('is-loading');

    setLoading(stickyBtn, origIsLoading);
    if (!origIsLoading) inFlight = false; // unlock when original returns to normal
  }

  // IntersectionObserver: show sticky when original is out of view
  const io = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyWrap.classList.remove('is-visible');
        stickyWrap.setAttribute('aria-hidden', 'true');
      } else {
        stickyWrap.classList.add('is-visible');
        stickyWrap.setAttribute('aria-hidden', 'false');
      }
    },
    { threshold: 0.15 }
  );
  io.observe(originalBtn);

  // Observe the original button for loading/disabled/text changes
  const mo = new MutationObserver(mirrorFromOriginal);
  mo.observe(originalBtn, { attributes: true, childList: true, subtree: true });

  // Initial sync
  mirrorFromOriginal();

  // Click behavior: mimic loading immediately + submit the real form reliably
  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (inFlight) return;

    // If original is disabled (eg variant not selected), just forward focus/scroll
    if (originalBtn.disabled) {
      originalBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      originalBtn.focus({ preventScroll: true });
      return;
    }

    inFlight = true;
    setLoading(stickyBtn, true); // ✅ hide text, show spinner immediately

    // Submit via requestSubmit for best compatibility
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(originalBtn);
    } else {
      // Fallback: click original (older browsers)
      originalBtn.click();
    }

    // Safety unlock in case theme never toggles back (prevents “stops working”)
    window.setTimeout(() => {
      // If original is no longer loading, unlock; otherwise keep locked
      mirrorFromOriginal();
      if (!stickyBtn.classList.contains('is-loading')) inFlight = false;
    }, 2500);
  });

  // Optional: also unlock if the form triggers a "submit" event (some themes prevent default)
  form.addEventListener('submit', () => {
    // keep it loading; MutationObserver will unlock when original toggles back
    setLoading(stickyBtn, true);
  });
});